import React, {PureComponent} from 'react'
import {Form, Input, Modal, InputNumber, Select} from 'antd'
const {Option} = Select;
const formItemLayout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 14,
    },
};
const title = {
    add: '新增报关单',
    update: '修改报关单'
};
class DeclareModal extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            record: {}
        }
    }

    handleOk = () => {
        const {onOk} = this.props;
        const {validateFields, resetFields} = this.props.form;
        validateFields((errors, values) => {
            if (errors) {
                return
            }
            onOk(values);
            resetFields();
            this.setState({record: {}});
        })
    };
    handleCancel = () => {
        const {onCancel} = this.props;
        const {resetFields} = this.props.form;
        onCancel();
        resetFields();
        this.setState({record: {}});
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.record && nextProps.view && nextProps.action == 'update' && !Object.is(nextProps.record, this.state.record)) {
            const {setFieldsValue} = this.props.form;
            setFieldsValue(nextProps.record);
            this.setState({record: nextProps.record})
        }
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        const {view, action, boxNoList} = this.props;
        let options;
        if (boxNoList != null) {
            options = boxNoList.map(d => <Option key={d} value={d}>{d}</Option>);
        }
        return (
            <Modal title={title[action]}
                   visible={view}
                   onOk={this.handleOk}
                   onCancel={this.handleCancel}
                   okText="确定"
                   cancelText="取消">
                <Form {...formItemLayout}>
                    <Form.Item label="集装箱号">
                        {getFieldDecorator('boxNo', {
                            rules: [{required: true, message: '该项必填'}]
                        })(<Select>
                            {options}
                        </Select>)}
                    </Form.Item>
                    <Form.Item label="报关代码:">
                        {getFieldDecorator('declareCode', {
                            initialValue: '9610',
                            rules: [{required: true, message: '该项必填'}]
                        })(<Select>
                            <Option value="9610">9610</Option>
                            <Option value="1210">1210</Option>
                            <Option value="0110">0110</Option>
                            <Option value="1616">1616</Option>
                        </Select>)}
                    </Form.Item>
                    <Form.Item label="报关单号:">
                        {getFieldDecorator('declareNo', {
                            //rules: [{required: true, message: '该项必填'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="货值:">
                        {getFieldDecorator('boxValue', {
                            rules: [{required: true, message: '该项必填'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="币制:">
                        {getFieldDecorator('currency', {
                            initialValue: 'CNY',
                            rules: [{required: true, message: '该项必填'}]
                        })(<Select>
                            <Option value="CNY">CNY</Option>
                            <Option value="USD">USD</Option>
                            <Option value="EUR">EUR</Option>
                        </Select>)}
                    </Form.Item>
                    <Form.Item label="票数:">
                        {getFieldDecorator('nums', {
                            rules: [{required: true, message: '该项必填'}]
                        })(<InputNumber min={0} step={1}/>)}
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}
const DeclareModalForm = Form.create()(DeclareModal)
export default DeclareModalForm
